import {BaseComponent} from '@shared/base.component';
import {Component, OnInit} from '@angular/core';
import {FormArray, FormControl, FormGroup, ValidatorFn} from '@angular/forms';

@Component({
    template: ''
  })
export class BaseFormComponent extends BaseComponent implements OnInit {
  submitted = false;
  myForm: FormGroup;
  inValid: boolean;

  constructor() {
    super();
  }
  ngOnInit() {
    this.submitted = false;
  }

  isFieldInvalid(field: string, checkIfSubmit = true) {
    if (!this.myForm || !this.myForm.get(field) || !this.getErrors(field)) {
      return false;
    }
    return checkIfSubmit
      ? (!this.myForm.get(field).valid && this.myForm.get(field).touched) ||
          (this.myForm.get(field).untouched && this.submitted)
      : (!this.myForm.get(field).valid && this.myForm.get(field).touched) ||
          this.myForm.get(field).untouched;
  }
  displayFieldCss(field: string, checkIfSubmit = true) {
    return {
      'has-error': this.isFieldInvalid(field, checkIfSubmit)
    };
  }
  getErrors(field: string) {
    const control = this.myForm.get(field);
    if (control) {
      return control.errors;
    }
  }

  setFormControlValue(formControlName: string, result: boolean| null) {
    const formControl = <FormControl>this.myForm.controls[formControlName];
    if (!formControl) {
      return;
    }
    formControl.setValue(result);
  }
  getFormControlValue(formControlName: string) {
    const formControl = <FormControl>this.myForm.controls[formControlName];
    if (!formControl) {
      return;
    }
    return formControl.value;
  }
  formInitialized(name: string, formGroup: FormGroup) {
    if (this.myForm && name && formGroup) {
      this.myForm.setControl(name, formGroup);
    }
  }
  getFormGroup(formGroupName: string): FormGroup {
    return this.myForm.get(formGroupName) as FormGroup;
  }
  getFormArray(formArrayName: string): FormArray {
    return this.myForm.get(formArrayName) as FormArray;
  }
  addToFormArray(name: string, formGroup: FormGroup) {
    if (this.myForm && name && formGroup) {
      (this.myForm.get(name) as FormArray).push(formGroup);
    }
  }
  emptyFormArray(formArray: FormArray) {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }
  clearValidators(control: FormControl) {
    control.clearValidators();
    control.updateValueAndValidity();
  }
  setValidators(control: FormControl, validators: ValidatorFn | ValidatorFn[]) {
    control.setValidators(validators);
    control.updateValueAndValidity();
  }
  scrollToError(
    containerName: string = null,
    scrollToCenter: boolean = true
  ): void {
    const invalidNodeNames = ['INPUT', 'TEXTAREA'];
    let errorElements: any;
    if (!containerName) {
      errorElements = document.getElementsByClassName('ng-invalid');
    } else {
      errorElements = document
        .getElementsByClassName(containerName)[0]
        .getElementsByClassName('ng-invalid');
    }
    if (errorElements.length > 0) {
      for (let i = 0; i < errorElements.length; i++) {
        if (invalidNodeNames.indexOf(errorElements[i].nodeName) >= 0) {
          this.scrollToElement(errorElements[i], scrollToCenter);
          return;
        }
      }
    }
  }
  public scrollToElement(
    htmlElement: HTMLElement,
    scrollToCenter: boolean = true
  ) {
    if (htmlElement) {
      htmlElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      });
      htmlElement.focus();
      if (scrollToCenter) {
        // scroll to center of screen
        const elementRect = htmlElement.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const middle = absoluteElementTop - window.innerHeight / 2;
        window.scrollTo(0, middle);
        return;
      }
    }
  }
  scrollToTop(offset = 80) {
    window.scrollTo(0, offset);
  }

  onSubmit() {
    this.submitted = true;
  }
}
